import React, { FunctionComponent, useState } from 'react';
import NavItem from './NavItem';
import ViewPDF from '../../ViewPDF';

interface PdfNavItemProps {
    fileName: string;
    navItemTitle: string;
    initialPageNumber?: number;
    icon: React.ReactNode;
}

const PdfNavItem: FunctionComponent<PdfNavItemProps> = ({ fileName, navItemTitle, initialPageNumber, icon }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <NavItem onClick={() => setIsOpen(true)} icon={icon}>
                {navItemTitle}
            </NavItem>
            <ViewPDF
                isOpen={isOpen}
                fileName={fileName}
                fileTitle={navItemTitle}
                initialPageNumber={initialPageNumber}
                onClose={() => setIsOpen(false)}
            />
        </>
    );
};

export default PdfNavItem;
